import React, {useState} from "react";

import Avatar from "react-avatar";
import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";

import Pagination from "components/Pagination";
import {i18n} from "translate/i18n";

import {useQuery, useQueryClient} from "react-query";
import {deleteUsersDashboard, getDashboardUsers} from "services/Users.service";
import {getProfile} from "utils";
import {swalClose, swalLoading, swalQuestion} from "../../../components/Swal";
import {loginRequest} from "../../../auth/authAzure";
import {useMsal} from "@azure/msal-react";
import {deleteUser} from "../../../services/Graph.service";

export const ListUsers = () => {

    const [users, setUsers] = useState([]);
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState([]);

    const { instance, accounts } = useMsal();
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const {isFetching} = useQuery(['users', currentPage],
        () => {
            return getDashboardUsers(true, currentPage)
        },
        {
            onSuccess: (res) => {
                setUsers(res.data)
                setPaginate({
                    from: res.from,
                    to: res.to,
                    total: res.total
                })
            },
            refetchOnWindowFocus: false
        })


    const handleChange = (id) => {
        navigate(`/users/edit/${id}`)
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const handleDelete = (id) => {
        swalQuestion(`<b>${i18n.t('questions.deleteUser')}</b>`)
            .then((result) => {
                if (result.isConfirmed) {

                    swalLoading()

                    instance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0]
                    }).then((response) => {

                        deleteUser(response?.accessToken, id).then(response => {

                            if (response) {
                                queryClient.invalidateQueries(["users", currentPage])
                                console.log('delete user', response)
                                swalClose()
                            }

                        });
                    })

                    deleteUsersDashboard(id).then(res => console.log('delete', res));
                }
            })
    }

    return (
        <div className="card mt-3 border-0 shadow-sm">
            <div className="card-header py-3">
                {/*<Link className="btn btn-outline-success px-5 py-2 float-end bi-plus" to={'/users/add'}>*/}
                {/*    {i18n.t('buttons.add')}*/}
                {/*</Link>*/}
            </div>
            <div className="card-body p-0 table-responsive">
                <table className="table align-middle mb-0">
                    <thead className="bg-primary text-uppercase text-sm">
                    <tr>
                        <th className="py-4">{i18n.t('label.user')}</th>
                        <th className="py-4">Perfil</th>
                        <th className="py-4">Status</th>
                        {/*<th className="py-4">{i18n.t('label.createdAt')}</th>*/}
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {users?.map((user, index) => (
                        <tr key={index}>
                            <td>
                                <Avatar name={user.username} round={true} size={30}/>
                                <span className="fw-bolder ms-2"> {user.username}</span>
                            </td>
                            <td>
                                { getProfile(user.profile) }
                            </td>
                            <td>
                                { user.status === 1
                                    ? <span className="badge bg-success">Ativo</span>
                                    : <span className="badge bg-danger">Inativo</span>
                                }
                            </td>
                            {/*<td>*/}
                            {/*     { format(new Date(user.created_at), 'dd/MM/yyyy', {locale: ptBR}) }*/}
                            {/*</td>*/}
                            <td>
                                <div className="d-flex gap-2 float-end">
                                    {/*<button*/}
                                    {/*    type="button"*/}
                                    {/*    className="btn btn-outline-danger btn-sm bi-trash"*/}
                                    {/*    onClick={() => handleDelete(user.id)}*/}
                                    {/*/>*/}
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm bi-pencil"
                                        onClick={() => handleChange(user.id)}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="card-footer bg-white border-top-0">
                <Pagination
                    isFetching={isFetching}
                    paginate={paginate}
                    handlePageClick={handlePageClick}
                />
            </div>
        </div>
    )
}
